import type { PrintSalesAllowedCountry } from './printSalesCountryList.types';

const isValidPrintSalesAllowedCountry = (payload: unknown): payload is PrintSalesAllowedCountry => {
  if (!payload || typeof payload !== 'object') {
    return false;
  }

  const hasOwn = (key: string) => Object.prototype.hasOwnProperty.call(payload, key);

  return hasOwn('code') && hasOwn('countryName') && hasOwn('print') && hasOwn('digital') && hasOwn('currency');
};

export const isValidPrintSalesAllowedCountryListPayload = (payload: unknown): payload is PrintSalesAllowedCountry[] => {
  if (!payload || !Array.isArray(payload) || !payload.length) {
    return false;
  }

  return !payload.some(item => !isValidPrintSalesAllowedCountry(item));
};
